import { createStore as s } from "./store.js";
const a = s(
  (o) => ({
    dialog: null,
    openDialog: (l, e) => o({ dialog: { name: l, options: e } }, !1, "dialogs/openDialog"),
    closeDialog: () => o({ dialog: null }, !1, "dialogs/closeDialog")
  }),
  {
    name: "Dialogs"
  }
), g = () => {
  const o = a.use.openDialog(), l = a.use.closeDialog();
  return { openDialog: o, closeDialog: l };
};
export {
  g as useDialogs,
  a as useDialogsStore
};
